// extracted by mini-css-extract-plugin
module.exports = {"root":"Prospects-module__root___r_H4b","image":"Prospects-module__image___2WtR0","desc":"Prospects-module__desc___3dpyD"};